export interface SharedTemplate {
  id: string
  name: string
  department: string
  description: string
  createdAt: string
  views: number
  favorites: number
  category: string  // 业务分类
  scenario: string  // 场景
  scope: string     // 我的/本机构/全部
  classification?: string  // 分类：规模/拓户/效益/账户/其他
  tags?: string[]          // 标签：八个壹/猎户行动/重点项目/常态关注
}

export const SHARED_TEMPLATES: SharedTemplate[] = [
  {
    id: '1',
    name: '对公大额存款变动',
    department: '金融科技部（数字化转型办公室）',
    description: 'T+1日统计当日对公客户大额存款余额变动情况，并展示最大一笔跨行转出交易对手，助您及时了解客户资金动向',
    createdAt: '2024-01-15',
    views: 256,
    favorites: 18,
    category: '对公业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '规模',
    tags: ['常态关注'],
  },
  {
    id: '12a',
    name: '一年期及以下对公存款日均增量',
    department: '金融科技部（数字化转型办公室）',
    description: 'T+1日统计各机构对公客户存款时点与年日均，并提供比上日、比上月、比上季、比年初的比值，您可直观了解存款时点与日均的变化情况',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '对公业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '规模',
    tags: ['八个壹'],
  },
  {
    id: '102',
    name: '公司价值户净增',
    department: '金融科技部（数字化转型办公室）',
    description: 'T+1日统计各机构基础客户、价值客户、高价值客户、核心客户的时点户数及净增情况，助您及时了解辖内各等级客户现状',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '对公业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '拓户',
    tags: ['猎户行动', '八个壹'],
  },
  {
    id: '12b',
    name: '一年期及以下个人存款日均增量',
    department: '金融科技部（数字化转型办公室）',
    description: 'T+1日统计各机构个人客户存款时点与年日均，并提供比上日、比上月、比上季、比年初的比值，您可直观了解存款时点与日均的变化情况',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '零售业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '规模',
    tags: ['八个壹'],
  },
  {
    id: '101',
    name: '普惠贷款增量',
    department: '金融科技部（数字化转型办公室）',
    description: 'T+1日展示辖内普惠小微客户贷款明细，数据取自信贷系统、个贷系统，其中客户单户余额是指该客户名下各借据时点贷款余额的汇总，跨系统数据助您一键获取',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '对公业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '规模',
    tags: ['常态关注', '八个壹'],
  },
  {
    id: '103',
    name: '对公客户等级变动提醒',
    department: '金融科技部（数字化转型办公室）',
    description: '对公客户等级升降变动监测与提醒',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '对公业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '拓户',
    tags: ['常态关注'],
  },
  {
    id: '104',
    name: '对公新开客户转换情况',
    department: '金融科技部（数字化转型办公室）',
    description: 'T+1日统计各机构当周、当月、当年客户开户及转化情况，助您直观了解开户客户的质量情况',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '对公业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '拓户',
    tags: ['常态关注'],
  },
  {
    id: '105',
    name: '零售自营理财及非存款',
    department: '金融科技部（数字化转型办公室）',
    description: '零售自营理财及非存款产品规模、收益统计',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '零售业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '规模',
    tags: ['常态关注'],
  },
  {
    id: '106',
    name: '个人基础及以上客户净增明细',
    department: '金融科技部（数字化转型办公室）',
    description: 'T+1日展示辖内个人基础及以上净增客户，个人基础客户是指近90天AUM日均在1000元及以上的客户（不含二类、三类户及存量纯社保医保客户）',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '零售业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '拓户',
    tags: ['猎户行动'],
  },
  {
    id: '107',
    name: '个人私钻客户净增',
    department: '金融科技部（数字化转型办公室）',
    description: '个人私钻客户数量净增统计',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '零售业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '拓户',
    tags: ['猎户行动', '八个壹'],
  },
  {
    id: '108',
    name: '个人专项客户净增统计',
    department: '金融科技部（数字化转型办公室）',
    description: '个人专项客户（含养老、代发等）净增统计',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '零售业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '拓户',
    tags: ['猎户行动'],
  },
  {
    id: '109',
    name: '个贷客户净增统计',
    department: '金融科技部（数字化转型办公室）',
    description: '个人贷款客户数量净增统计',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '零售业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '拓户',
    tags: ['猎户行动'],
  },
  {
    id: '110',
    name: '个人贷款增量统计',
    department: '金融科技部（数字化转型办公室）',
    description: '个人贷款余额及增量统计，支持按产品类型拆分',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '零售业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '规模',
    tags: ['八个壹'],
  },
  {
    id: '111',
    name: '个人大额存款变动',
    department: '金融科技部（数字化转型办公室）',
    description: '个人客户大额存款余额变动监测与预警',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '零售业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '规模',
    tags: ['常态关注'],
  },
  {
    id: '112',
    name: '零售理财到期明细',
    department: '金融科技部（数字化转型办公室）',
    description: '零售客户理财产品到期明细及续接情况',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '零售业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '规模',
    tags: ['常态关注'],
  },
  {
    id: '113',
    name: '三方存管和代发业务统计',
    department: '金融科技部（数字化转型办公室）',
    description: '三方存管及代发工资业务量统计',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '零售业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '拓户',
    tags: ['常态关注'],
  },
  {
    id: '114',
    name: '"粤来粤亲"社区项目统计',
    department: '金融科技部（数字化转型办公室）',
    description: '"粤来粤亲"社区推广项目参与情况及成效统计',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '零售业务',
    scenario: '营销推动',
    scope: 'all',
    classification: '拓户',
    tags: ['重点项目'],
  },
  {
    id: '115',
    name: '重点产品销量统计',
    department: '金融科技部（数字化转型办公室）',
    description: '重点零售产品销量及排名统计',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '零售业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '规模',
    tags: ['常态关注'],
  },
  {
    id: '116',
    name: '有效代发工资单位客户新增统计',
    department: '金融科技部（数字化转型办公室）',
    description: '代发工资单位新签约情况及激活率统计',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '零售业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '拓户',
    tags: ['八个壹'],
  },
  {
    id: '117',
    name: '新客户开户统计',
    department: '金融科技部（数字化转型办公室）',
    description: '新客户开户数量及渠道分布统计',
    createdAt: '2026-06-10',
    views: 0,
    favorites: 0,
    category: '零售业务',
    scenario: '业绩考核',
    scope: 'all',
    classification: '拓户',
    tags: ['常态关注'],
  },
]

export const CATEGORIES = [
  '零售业务', '对公业务', '金融市场', '风险合规', '财务会计', '运营管理', '其他',
]

export const SCENARIOS = [
  '业绩考核', '营销推动', '网点产能', '流程优化', '风险合规',
]

export const CLASSIFICATIONS = [
  '规模', '拓户', '效益', '账户', '其他',
]

export const TAGS = [
  '八个壹', '猎户行动', '重点项目', '常态关注',
]

export const SCOPES = [
  { value: 'all', label: '全部' },
  { value: 'mine', label: '我的共享' },
  { value: 'headquarters', label: '总行共享' },
  { value: 'branch', label: '分行共享' },
  { value: 'subbranch', label: '网点共享' },
  { value: 'institution', label: '选择机构' },
]

export interface InstitutionNode {
  id: string
  name: string
  children?: InstitutionNode[]
}

export const INSTITUTION_TREE: InstitutionNode[] = [
  {
    id: 'hq',
    name: '总行',
    children: [
      { id: 'gz', name: '广州分行', children: [
        { id: 'gz-hz', name: '海珠中心支行', children: [
          { id: 'gz-hz-ckl', name: '昌岗路支行' },
          { id: 'gz-hz-cg', name: '赤岗支行' },
          { id: 'gz-hz-dh', name: '敦和支行' },
          { id: 'gz-hz-gydb', name: '工业大道北支行' },
          { id: 'gz-hz-blt', name: '广州保利天悦支行' },
          { id: 'gz-hz-gbzx', name: '广州广报中心支行' },
          { id: 'gz-hz-hn', name: '广州华南支行' },
        ]},
        { id: 'gz-df', name: '东风支行' },
        { id: 'gz-fc', name: '广州芳村支行' },
        { id: 'gz-fy', name: '逢源支行' },
        { id: 'gz-tx', name: '天河支行' },
      ]},
      { id: 'fs', name: '佛山分行', children: [
        { id: 'fs-cc', name: '禅城支行' },
        { id: 'fs-nh', name: '南海支行' },
        { id: 'fs-sd', name: '顺德支行' },
      ]},
      { id: 'dg', name: '东莞分行', children: [
        { id: 'dg-gc', name: '莞城支行' },
        { id: 'dg-nch', name: '南城支行' },
        { id: 'dg-ech', name: '东城支行' },
      ]},
      { id: 'hz', name: '惠州分行', children: [
        { id: 'hz-ech', name: '惠城支行' },
        { id: 'hz-hy', name: '惠阳支行' },
        { id: 'hz-bd', name: '博罗支行' },
      ]},
    ],
  },
]
